<template>
    <div class="recipe-item" v-if="categoryData.length > 0 " @click="GTMProdCatClick(name)"> 
        <router-link :to="{ name:'RecipeDetails_' + currentLangName(), params: {recipe_slug: recipe_slug, recipes_category_slug: categoryData[0].slug}}" >
            <div class="recipe-item__img-wrap">
                <img v-if="src!='no-image'"                  
                    :srcset="srcset" 
                    :alt="name" 
                    :title="name" 
                    class="img-fluid recipe-item__img lazy_load_img"                     
                    sizes="(max-width: 575px) 100vw
                    (min-width:576px and max-width: 767px) 50vw, 370px" 
                    :src="src_url + '/' + src" 
                />
                <!-- <img ref="lazy_img" v-else-if="src!='no-image' && lazy_load==true"  
                    :data-srcset="srcset" 
                    :alt="name" 
                    :title="name" 
                    class="img-fluid recipe-item__img lazy_load_img"                     
                    sizes="(max-width: 575px) 100vw
                    (min-width:576px and max-width: 767px) 50vw, 370px" 
                    :data-src="src_url + '/' + src" 
                    src='@/assets/images/noimage/recept-no-image.svg' 
                /> -->
                <img v-else
                    src='@/assets/images/noimage/recept-no-image.svg' 
                    :alt="name" 
                    :title="name" 
                    class="img-fluid recipe-item__img"
                 />
                <div class="recipe-item__category-name" v-if="categoryData.length > 0">                    
                    <span v-for="categoryName in categoryData" :key="categoryName.id">
                        {{ categoryName.name }}
                    </span>
                </div> 
                <div class="recipe-item__data">
                    <div class="making-time">{{ making_time }}</div>
                    <div class="dish">{{ dish }}</div>
                    <div class="difficulty">{{ difficulty }}</div>
                </div>
            </div>                             
            <div class="recipe-item__name">{{  name }}</div>  
            <div class="recipe-item__btn-wrap">              
                <div class=" btn btn--green-border" >{{ lang('recept_elolvasom')}}    </div>
            </div>     
        </router-link>                                                                                    
    </div>
</template>

<script>


export default {
    data(){
        return {
            categoryId: [],
            src_url: process.env.VUE_APP_BIFROST_API_URL_NO_PROJECTNAME
        }
    },   
    // props: ['name', 'id', 'recipe_slug', 'srcset', 'src', 'difficulty', 'dish', 'making_time', 'lazy_load'],
    props: ['name', 'id', 'recipe_slug', 'srcset', 'src', 'difficulty', 'dish', 'making_time'],
    computed:{                      
        categoryData(){             
            let categoryArray = this.$store.getters.getRecipesCategory;                   
            return this.getCategoryData(this.id, categoryArray  )
        }        
    },
    methods:{
        // lazyImg(){            
           
        //     if (this.$refs.lazy_img){                
        //         var scrollTop = window.pageYOffset;                
            
        //         var getElemDistance = function ( elem ) {
        //             var location = 0;
        //             if (elem.offsetParent) {
        //                 do {
        //                     location += elem.offsetTop;
        //                     elem = elem.offsetParent;
        //                 } while (elem);
        //             }
        //             return location >= 0 ? location : 0;
        //         };          
                
        //         var element = this.$refs.lazy_img
        //         var location = getElemDistance( element );

        //         console.log(location, this.name)

        //         if( location < (window.innerHeight + scrollTop + 100))  {
        //             element.setAttribute('src', this.src)
        //             element.setAttribute('srcset', this.srcset)
        //         }       
                
        //         // console.log(location)
        //     }
        // },
        GTMProdCatClick(recipe){          
            this.setDataLayer('recipe_details', recipe, '')                  
        }
    },
    mounted(){                       
        // this.lazyImg()
        // document.addEventListener("scroll", this.lazyImg);
        // window.addEventListener("resize", this.lazyImg);
        // window.addEventListener("orientationChange", this.lazyImg);
    },
    destroyed(){
        // document.removeEventListener("scroll", this.lazyImg);
        // window.removeEventListener("resize", this.lazyImg);
        // window.removeEventListener("orientationChange", this.lazyImg);
    }
}
</script>